/* ==========================================================================
   Ryse - Theoric PDP (tema copia lab-miolo, 20/07/2026).
   DESATIVADO. A REGRA 1 antiga recolhia o card de Beneficios ("Ver mais") para
   alinhar a coluna de compra a base da galeria. No novo layout a coluna direita
   passou a ter Beneficios + ABAS (Sobre/Caract./Formula) + add-on, entao esse
   recolhimento embolava tudo. Agora a coluna flui natural e usa o sticky nativo
   do tema. Mantido como no-op so pra nao quebrar a referencia do loader; tambem
   limpa qualquer estado antigo (max-height/recolhido/botao) que tenha sobrado.
   ========================================================================== */
(function () {
  'use strict';
  var benef = document.querySelector('#theoric-pdp-novo .tpn__benef');
  if (benef) {
    benef.style.maxHeight = '';
    benef.classList.remove('tpn__benef--recolhido');
    var vm = benef.querySelector('.tpn__benef-vermais');
    if (vm) vm.remove();
  }
})();